import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '../../../common/services/data.service';
import { UserCacheService } from '../../../common/services/user-cache.service';
import { AppConstants } from '../../../common/constants/app-constants';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNotFoundComponent implements OnInit {

  constructor(
    public userCacheService: UserCacheService,
    public dataService: DataService
    ) {
    userCacheService.eraseAllUserData();
    this.dataService.doAnnouncement({ topic: AppConstants.STORY_ID, message: null });
    this.dataService.doAnnouncement({ topic: AppConstants.PARTICIPATION_ID, message: null });
    this.dataService.doAnnouncement({ topic: AppConstants.TOKEN, message: null });
    this.dataService.doAnnouncement({ topic: AppConstants.GLOBAL_HEADER, message: null });
  }

  ngOnInit(): void {
  }

}
